var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrgGroupsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Org_Groups_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Org_Groups_Active",
    "data-name": "Org Groups_Active",
    clipPath: "url(#clip-Org_Groups_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Org_Groups",
    "data-name": "Org Groups",
    transform: "translate(1 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_44",
    "data-name": "Subtraction 44",
    d: "M-1347.789-585.087h-.61a1.456,1.456,0,0,1-1.454-1.454V-589.1a1.08,1.08,0,0,1,.023-.274,4.967,4.967,0,0,1,.233-.834h-7.069a1.337,1.337,0,0,1-1.335-1.336v-1.812a.913.913,0,0,1,.023-.25,3.922,3.922,0,0,1,3.839-3.171h2.909a3.922,3.922,0,0,1,3.839,3.171,1.509,1.509,0,0,1,.023.25v.55a5.025,5.025,0,0,1,2.461-.645h3.85a5.008,5.008,0,0,1,2.424.626v-.531a.913.913,0,0,1,.023-.25,3.922,3.922,0,0,1,3.839-3.171h2.909a3.922,3.922,0,0,1,3.839,3.171,1.812,1.812,0,0,1,.023.25v1.812a1.337,1.337,0,0,1-1.335,1.336h-7.034a5.048,5.048,0,0,1,.236.834,1.848,1.848,0,0,1,.024.274v2.563a1.456,1.456,0,0,1-1.454,1.454h-.648a4.979,4.979,0,0,0-4.789-3.541,4.978,4.978,0,0,0-4.788,3.541ZM-1343-594.9a3.95,3.95,0,0,1-3.946-3.946A3.95,3.95,0,0,1-1343-602.8a3.95,3.95,0,0,1,3.946,3.946A3.95,3.95,0,0,1-1343-594.9Zm9.683-2.9a3.1,3.1,0,0,1-3.1-3.1,3.1,3.1,0,0,1,3.1-3.1,3.1,3.1,0,0,1,3.1,3.1A3.1,3.1,0,0,1-1333.317-597.8Zm-19.367,0a3.1,3.1,0,0,1-3.1-3.1,3.1,3.1,0,0,1,3.1-3.1,3.1,3.1,0,0,1,3.1,3.1A3.1,3.1,0,0,1-1352.684-597.8Z",
    transform: "translate(1358 604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2164",
    "data-name": "Group 2164",
    transform: "translate(3.54 12.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4740",
    "data-name": "Path 4740",
    d: "M10.07,23.864H7.28a.478.478,0,0,1-.477-.477L6.72,16.319A.5.5,0,0,1,7.2,15.83h0a.478.478,0,0,1,.477.477L7.745,22.9h2.312a.477.477,0,0,1,0,.954Z",
    transform: "translate(-6.72 -15.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4741",
    "data-name": "Path 4741",
    d: "M25.336,23.862H22.547a.477.477,0,1,1,0-.954h2.313l.072-6.592a.478.478,0,0,1,.477-.477h0a.489.489,0,0,1,.477.489L25.8,23.4a.478.478,0,0,1-.477.477Z",
    transform: "translate(-2.977 -15.828)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2163",
    "data-name": "Group 2163",
    transform: "translate(9.505 14.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4738",
    "data-name": "Path 4738",
    d: "M16.885,28.337a5.485,5.485,0,1,1,5.006-7.7h0a5.5,5.5,0,0,1-2.8,7.235,5.564,5.564,0,0,1-2.217.465Zm-.012-10.025a2.952,2.952,0,1,0,0-.012Z",
    transform: "translate(-11.39 -17.366)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4739",
    "data-name": "Path 4739",
    d: "M19.4,22.873v-.846l-.6-.048a2.309,2.309,0,0,0-.346-.846l.393-.453-.6-.608-.465.393a2.554,2.554,0,0,0-.846-.358l-.036-.608h-.846l-.048.6a2.309,2.309,0,0,0-.846.346l-.453-.393-.608.6.393.465a2.554,2.554,0,0,0-.358.846l-.608.036v.846l.6.048a2.309,2.309,0,0,0,.346.846l-.393.453.6.608.465-.393a2.554,2.554,0,0,0,.846.358l.036.608h.846l.048-.6a2.309,2.309,0,0,0,.846-.346l.453.393.3-.3.3-.3-.393-.465a2.554,2.554,0,0,0,.358-.846l.608-.036Zm-2.312.191a.894.894,0,0,1-.62.262.846.846,0,0,1-.62-.262.894.894,0,0,1-.262-.62.846.846,0,0,1,.262-.62.894.894,0,0,1,.62-.262.846.846,0,0,1,.62.262.894.894,0,0,1,.262.62A.846.846,0,0,1,17.092,23.064Z",
    transform: "translate(-1.472 -2.054)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgGroupsActive);
export default __webpack_public_path__ + "static/media/Org_Groups_Active.56bf5ec8e9ac3df77c14259b37dae43e.svg";
export { ForwardRef as ReactComponent };